import { useState } from "react";

import {
  MANOEUVRES,
  MANOEUVRE_IDS,
  type MobManoeuvre,
} from "@nav-games/mob";

import { MobFigure } from "../../ui/MobFigure";

interface MobProps {
  onNavigate: (to: string) => void;
}

const VESSEL_LABEL: Record<MobManoeuvre["vessel"], string> = {
  sail: "Sailing",
  power: "Power-driven",
  any: "Any vessel",
};

export function Mob({ onNavigate }: MobProps) {
  const [selectedId, setSelectedId] = useState<string>(MANOEUVRE_IDS[0]!);
  const [playKey, setPlayKey] = useState(0);
  const m = MANOEUVRES[selectedId]!;

  return (
    <>
      <h2 style={{ marginTop: 0 }}>Man-overboard recovery</h2>
      <p className="muted">
        Six standard manoeuvres. Pick one to watch the animation and
        read the helmsman's steps. Critical safety skill — drill these
        until they're automatic.
      </p>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Always do these first</h3>
        <ol className="small" style={{ paddingLeft: 18, margin: 0 }}>
          <li>
            <strong>Shout</strong> "MAN OVERBOARD!" and the side
            (port / starboard).
          </li>
          <li>
            <strong>Throw</strong> a lifering, danbuoy, and anything
            else that floats toward the casualty.
          </li>
          <li>
            <strong>Designate a spotter</strong> who does NOTHING but
            keep eyes on the casualty and point.
          </li>
          <li>
            <strong>Press MOB</strong> on the plotter / GPS to mark
            the position.
          </li>
          <li>
            <strong>VHF Mayday</strong> on Channel 16 if the casualty
            isn't recovered within 1–2 minutes.
          </li>
        </ol>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Choose a manoeuvre</h3>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {MANOEUVRE_IDS.map((id) => (
            <button
              key={id}
              className={id === selectedId ? "" : "secondary"}
              onClick={() => {
                setSelectedId(id);
                setPlayKey((k) => k + 1);
              }}
              style={{ fontSize: 13, padding: "8px 12px" }}
            >
              {MANOEUVRES[id]!.name}
            </button>
          ))}
        </div>
      </div>

      <div className="card">
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <h3 style={{ margin: 0 }}>{m.name}</h3>
          <span className="pill">{VESSEL_LABEL[m.vessel]}</span>
        </div>
        <p className="small muted" style={{ marginBottom: 8 }}>
          {m.summary}
        </p>
        <p className="small muted" style={{ margin: "0 0 12px" }}>
          <strong>Best for:</strong> {m.bestFor}
        </p>

        <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
          <MobFigure manoeuvre={m} playKey={playKey} size={320} />
        </div>
        <div style={{ textAlign: "center", marginBottom: 12 }}>
          <button
            className="secondary"
            onClick={() => setPlayKey((k) => k + 1)}
            style={{ fontSize: 13, padding: "6px 14px" }}
          >
            ↻ Replay animation
          </button>
        </div>

        <ol className="small" style={{ paddingLeft: 18, margin: 0 }}>
          {m.steps.map((s, i) => (
            <li key={i} style={{ marginBottom: 6 }}>
              {s}
            </li>
          ))}
        </ol>
      </div>

      <button className="secondary" onClick={() => onNavigate("/drills")}>
        ← Back to Drills
      </button>
    </>
  );
}
